import useSWR from "swr";
import { teamClient } from "../clients";
import { useLoggedinUser } from "./useLoggedinUser";

const fetcher = async () => {
  const { data } = await teamClient.getInvoices();
  return data;
}

export const useTeamInvoices = (config = {}) => {
  const { data: user } = useLoggedinUser();
  const { data, error, isValidating, mutate } = useSWR(user?.verified ? '/v1/user/teams/invoices' : null, fetcher, { ...config });

  return {
    data,
    isValidating,
    isLoading: !data && !error,
    error,
    mutate,
  };
};
